import { observer } from 'mobx-react-lite';
import { Navigate, Outlet } from 'react-router-dom';
import { useStore } from '@shared/hooks/useStore';
import { ROUTES } from '@shared/configs/constants';

export const StdIndividualGuard = observer(() => {
    const { authStore } = useStore();

    if (!authStore.isStdIndividual) {
        return <Navigate to={ROUTES.home.href} replace />;
    }

    return <Outlet />;
});
